import { automationModules } from 'constants/automationConstants';

const { EVENTS, TASKS, CASES, FILES, LEADS, MESSAGES, FORMS } = automationModules || {};

const eventAction = {
  label: 'Events',
  items: [{ label: 'Create Event', code: 'ACT_EVENT_CREATE', ruleValidationCode: 'EVENT_CREATE', module: EVENTS }],
};

const eventFilesAction = {
  label: 'Files',
  items: [{ label: 'Create Document From Template', code: 'ACT_CREATE_DOCUMENT', ruleValidationCode: 'CREATE_DOCUMENT', module: FILES }],
};

const leadAction = {
  label: 'Leads',
  items: [{ label: 'Convert Lead To Case', code: 'ACT_LEAD_CONV_CASE', ruleValidationCode: 'LEAD_CONV_CASE', module: LEADS }],
};

const caseAction = {
  label: 'Cases',
  items: [{ label: 'Close Case', code: 'ACT_CASE_CLOSE', ruleValidationCode: 'CASE_CLOSE', module: CASES }],
};

const filesAction = {
  label: 'Files',
  items: [
    { label: 'Create Folder Structure', code: 'ACT_BULK_UPLOAD_FOLDER', ruleValidationCode: 'BULK_UPLOAD_FOLDER', module: FILES },
    { label: 'Create Document From Template', code: 'ACT_CREATE_DOCUMENT', ruleValidationCode: 'CREATE_DOCUMENT', module: FILES },
  ],
};

const filesActionPastDue = {
  label: 'Files',
  items: [{ label: 'Create Document From Template', code: 'ACT_CREATE_DOCUMENT', ruleValidationCode: 'CREATE_DOCUMENT', module: FILES }],
};

const taskAction = {
  label: 'Tasks',
  items: [{ label: 'Create Task', code: 'ACT_TASK_CREATE', ruleValidationCode: 'TASK_CREATE', module: TASKS }],
};

const messageNotificationAction = {
  label: 'Messages & Notifications',
  items: [
    { label: 'Send Text Message', code: 'ACT_SEND_TEXT_MESSAGE', ruleValidationCode: 'SEND_TEXT_MESSAGE', module: MESSAGES },
    { label: 'Send Secure Message', code: 'ACT_SEND_SECURE_MESSAGE', ruleValidationCode: 'SEND_SECURE_MESSAGE', module: MESSAGES },
  ],
};

const reviewRequestMessageNotificationAction = {
  label: 'Send Review By',
  items: [
    {
      label: 'Send Text Message Reminder',
      code: 'ACT_SEND_TEXT_MESSAGE',
      ruleValidationCode: 'SEND_TEXT_MESSAGE',
      module: MESSAGES,
    },
    {
      label: 'Send Secure Message Reminder',
      code: 'ACT_SEND_SECURE_MESSAGE',
      ruleValidationCode: 'SEND_SECURE_MESSAGE',
      module: MESSAGES,
    },
  ],
};

const formAction = {
  label: 'Forms',
  items: [{ label: 'Share Form', code: 'ACT_SHARE_FORM', ruleValidationCode: 'SHARE_FORM', module: FORMS }],
};

export const leadActionsGrouped = [eventAction, taskAction, messageNotificationAction, filesAction];

export const taskActionsGrouped = [eventAction, messageNotificationAction];

export const eventActionsGrouped = [taskAction, messageNotificationAction, eventFilesAction];

export const billingActionsGrouped = [eventAction, taskAction, messageNotificationAction];

export const caseActionsGrouped = [eventAction, taskAction, messageNotificationAction, filesAction];

export const filesActionsGrouped = [eventAction, taskAction, messageNotificationAction];

export const contactActionsGrouped = [eventAction, taskAction, messageNotificationAction];

export const allActionsGrouped = [eventAction, leadAction, caseAction, filesAction, taskAction, messageNotificationAction];

export const pastDueAction = [taskAction, messageNotificationAction, filesActionPastDue];

export const reviewRequestSent = [reviewRequestMessageNotificationAction];

export const shareForm = [formAction];
